import { Purchases,
         Package as RCPackage
       } from "@revenuecat/purchases-js";
import { BillingAdapter, DisplayPackage, BillingCustomerInfo } from "./BillingAdapter";

export class BillingWeb implements BillingAdapter {
  private get rc() {
    return Purchases.getSharedInstance();
  }

  async getOfferings() {
    const offerings = await this.rc.getOfferings();
    const avail = offerings.current?.availablePackages ?? [];

    const display: DisplayPackage[] = avail.map((p: RCPackage) => ({
      identifier: p.identifier,
      priceText: p.webBillingProduct.price.formattedPrice,
      raw: p,
    }));

    return { availablePackages: display };
  }

  getCustomerInfo(): Promise<BillingCustomerInfo> {
    return this.rc.getCustomerInfo() as Promise<BillingCustomerInfo>;
  }

  async purchasePackage(
    pkg: DisplayPackage,
    opts?: { customerEmail?: string }
  ): Promise<BillingCustomerInfo> {
    const rcPackage = pkg.raw as RCPackage;

    const { customerInfo } = await this.rc.purchase({
      rcPackage,
      customerEmail: opts?.customerEmail,
    });

    return customerInfo as BillingCustomerInfo;
  }

  async restorePurchases(): Promise<BillingCustomerInfo> {
    return this.getCustomerInfo();
  }

  async setAttributes(attributes: Record<string, string>): Promise<void> {
    await this.rc.setAttributes(attributes);
  }
}
